import React from 'react'
import { Typography } from 'antd'
import { FFEDocument } from '../../types/ffe'

const { Text } = Typography

interface Props {
  document: FFEDocument
}

export const PrintFloorPlans: React.FC<Props> = ({ document }) => {
  const { floorPlans, lineItems, groups } = document

  if (!floorPlans.length) return null

  return (
    <div className="page-break-before">
      <Text strong className="text-xl block mb-8">
        Floor Plans & Space Links
      </Text>

      {floorPlans.map((plan) => (
        <div key={plan.id} className="mb-12">
          <Text strong className="text-lg block mb-4">
            {plan.name}
          </Text>
          <div className="relative">
            <img
              src={plan.imageUrl}
              alt={plan.name}
              style={{ width: 800, minWidth: 800 }}
              className="h-auto"
            />

            {plan.shapes.map((shape) => {
              const linkedItem = shape.linkedItemId
                ? lineItems.find((item) => item.id === shape.linkedItemId)
                : null
              const linkedGroup = shape.linkedGroupId
                ? groups.find((group) => group.id === shape.linkedGroupId)
                : null

              const label = linkedItem?.code || linkedGroup?.name
              if (!label) return null

              return (
                <div
                  key={shape.id}
                  className="absolute border-2 print:border-black print:bg-black/20"
                  style={{
                    left: shape.x,
                    top: shape.y,
                    width: shape.width,
                    height: shape.height,
                    borderRadius: shape.type === 'circle' ? '50%' : undefined
                  }}
                >
                  <div className="absolute -top-6 left-0 bg-white print:bg-white px-2 py-1 text-sm border rounded">
                    {label}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  )
}
